export default __webpack_public_path__ + "static/media/carousel-img-2.75b69d96.webp";